export const meta = {
    data: {
        title: '',
        code: '',
        originCode: '', // origin Word or other doc
        author: 'Banka CREDITAS a.s.',
        description: '',
        keywords: 'Creditas, email',
        subject: '',
        changeLog: '',
        version: '1.0',
    },
    footer: '',
};
